import Logo from "../layout/Logo";
import { Link } from "react-router-dom";

export function GoogleButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} data-testid="google-login-btn"
      className="flex h-12 w-full items-center justify-center gap-3 rounded-xl border border-slate-200 bg-white text-sm font-semibold text-navy transition-colors hover:bg-slate-50">
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" /></svg>
      Continue with Google
    </button>
  );
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <section className="grain relative min-h-[calc(100vh-72px)] overflow-hidden bg-navy py-16">
      <div className="grid-lines absolute inset-0" />
      <div className="aurora absolute -right-32 top-10 h-96 w-96 rounded-full bg-mint/15 blur-[120px]" />
      <div className="container-q relative flex justify-center">
        <div className="w-full max-w-md rounded-[2rem] bg-white p-8 shadow-2xl sm:p-10">
          <Link to="/" className="mb-8 inline-block"><Logo light={false} /></Link>
          <h1 className="text-2xl font-bold text-navy">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-center text-sm text-slate-600">{footer}</div>}
        </div>
      </div>
    </section>
  );
}
